const getters = {
  departmentTypes: state => state.department_types,
  departmentFilterTypes: state => state.department_filter_types
}

export default getters;
